export function detectLocale() {
  return window.navigator.language;
}
